import {
  FormErrors,
  useLocalization,
  useMasterData,
} from '@ui-framework/index';
import { useServiceProvider } from '../../../providers/ServiceProviderProvider';
import { useServiceJob } from '../../../providers/ServiceJobProvider';

function ServiceJobAssignCheck({
  isAssign = false,
  isReAssign = false,
  locationId,
  children,
}) {
  const { formatMessage } = useLocalization();
  const { serviceJob } = useServiceJob();
  const { serviceProvider, dispatchMethod } = useServiceProvider();
  const { pendingServiceJobStatus } = useMasterData();

  const canAssign = pendingServiceJobStatus.includes(
    serviceJob?.serviceJobStatus,
  );

  const isInActiveSP = serviceProvider?.status === 'INACTIVE';
  const isInActiveSPDispatchMethod =
    dispatchMethod?.dispatchMethod === 'INACTIVE';

  const errors = [];

  if (!canAssign) {
    if (isAssign) {
      errors.push({
        message: formatMessage({
          id: 'JOB_CANNOT_BE_ASSIGNED',
          defaultMessage: 'Job cannot be assigned',
        }),
      });
    }
    if (isReAssign) {
      errors.push({
        message: formatMessage({
          id: 'JOB_CANNOT_BE_REASSIGNED',
          defaultMessage: 'Job cannot be reassigned',
        }),
      });
    }
  }

  if (isInActiveSP) {
    errors.push({
      message: formatMessage({
        id: 'SERVICE_PROVIDER_IS_INACTIVE',
        defaultMessage: 'Service Provider is inactive',
      }),
    });
  }

  if (isInActiveSPDispatchMethod) {
    errors.push({
      message: formatMessage({
        id: 'SERVICE_PROVIDER_DISPATCH_METHOD_IS_INACTIVE',
        defaultMessage: 'Service Provider dispatch method is inactive',
      }),
    });
  }

  if (!locationId) {
    errors.push({
      message: formatMessage({
        id: 'SERVICE_PROVIDER_LOCATION_INFORMATION_NOT_PROVIDED',
        defaultMessage: 'Service Provider location information not provided',
      }),
    });
  }

  if (errors.length > 0) {
    return <FormErrors errors={errors} />;
  }
  return children;
}

export default ServiceJobAssignCheck;
